(() => {
'use strict';
const X = window.KPX;
if (!X) return;
const { $, $$, R, T, esc, fmt, sized, store, fine, calm, api, toast, burst, openModal, closeModal, addItems } = X;
const KP = window.KP || {};
const io = (fn, opt) => ('IntersectionObserver' in window) ? new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { fn(en.target); en.target.__io && en.target.__io.unobserve(en.target); } }), opt || { rootMargin: '0px 0px -60px 0px' }) : null;
const watch = (els, fn, opt) => { const o = io(fn, opt); els.forEach(el => { if (!o || calm) return fn(el); el.__io = o; o.observe(el); }); };

/* ---------- custom cursor ---------- */
if (fine && !calm && KP.cursor !== false) {
  const dot = document.createElement('div'), ring = document.createElement('div');
  dot.className = 'kp-cur-dot'; ring.className = 'kp-cur-ring'; ring.innerHTML = '<span></span>';
  document.body.append(dot, ring);
  document.documentElement.classList.add('kp-has-cursor');
  let mx = -100, my = -100, rx = -100, ry = -100;
  addEventListener('mousemove', e => { mx = e.clientX; my = e.clientY; dot.style.transform = 'translate(' + mx + 'px,' + my + 'px)'; }, { passive: true });
  (function loop() { rx += (mx - rx) * .18; ry += (my - ry) * .18; ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px)'; requestAnimationFrame(loop); })();
  document.addEventListener('mouseover', e => {
    const lab = e.target.closest('[data-cursor]');
    const hot = e.target.closest('a,button,[role=button],input,select,label,summary');
    ring.classList.toggle('is-label', !!lab);
    ring.classList.toggle('is-hot', !!hot && !lab);
    $('span', ring).textContent = lab ? lab.dataset.cursor : '';
  });
  document.addEventListener('mousedown', () => ring.classList.add('is-down'));
  document.addEventListener('mouseup', () => ring.classList.remove('is-down'));
  document.addEventListener('mouseleave', () => { dot.style.opacity = ring.style.opacity = 0; });
  document.addEventListener('mouseenter', () => { dot.style.opacity = ring.style.opacity = 1; });
}

/* ---------- page transitions ---------- */
const pt = $('#kp-pt');
if (pt && !calm) {
  requestAnimationFrame(() => pt.classList.add('is-out'));
  addEventListener('pageshow', e => { if (e.persisted) { pt.classList.remove('is-in'); pt.classList.add('is-out'); } });
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    if (a.target && a.target !== '_self') return;
    if (a.hasAttribute('download') || a.closest('[data-open-cart],[data-no-pt]') || a.matches('[data-open-cart],[data-open-search],[data-open-wish]')) return;
    const u = new URL(a.href, location.href);
    if (u.origin !== location.origin || (u.pathname === location.pathname && u.hash) || /\/(checkout|cart\/|discount\/|account\/logout)/.test(u.pathname)) return;
    e.preventDefault();
    pt.classList.remove('is-out'); pt.classList.add('is-in');
    setTimeout(() => { location.href = a.href; }, 420);
  });
}

/* ---------- word reveal on headings ---------- */
function splitWords(el) {
  if (el.dataset.words || el.querySelector('[data-split]')) return;
  el.dataset.words = '1';
  const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
  const nodes = []; while (walker.nextNode()) nodes.push(walker.currentNode);
  let i = 0;
  nodes.forEach(n => {
    const parts = n.textContent.split(/(\s+)/);
    const frag = document.createDocumentFragment();
    parts.forEach(p => {
      if (!p) return;
      if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
      const w = document.createElement('span'); w.className = 'kp-w';
      const s = document.createElement('span'); s.textContent = p; s.style.transitionDelay = (i++ * 55) + 'ms';
      w.appendChild(s); frag.appendChild(w);
    });
    n.parentNode.replaceChild(frag, n);
  });
}
if (!calm) {
  const hs = $$('.kp-h2, .kp-h3, .kp-pdp__title, .kp-page h1').filter(h => !h.closest('.kp-modal,.kp-drawer,.kp-age'));
  hs.forEach(splitWords);
  watch(hs, el => el.classList.add('is-words'));
}

/* ---------- image reveal, counters, parallax ---------- */
watch($$('[data-img-reveal]'), el => el.classList.add('is-shown'));
watch($$('[data-count]'), el => {
  const end = parseFloat(el.dataset.count) || 0, dec = (el.dataset.count.split('.')[1] || '').length, dur = 1600, t0 = performance.now();
  const suf = el.dataset.suffix || '', pre = el.dataset.prefix || '';
  const step = t => { const k = Math.min(1, (t - t0) / dur), v = end * (1 - Math.pow(1 - k, 3)); el.textContent = pre + v.toLocaleString(KP.locale || 'nl', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + suf; if (k < 1) requestAnimationFrame(step); };
  requestAnimationFrame(step);
});
const px = $$('[data-parallax]');
const pins = $$('[data-hpin]');
const bands = $$('.kp-band__track');
let lastY = scrollY, vel = 0, ticking = false;
function onFrame() {
  ticking = false;
  const vh = innerHeight;
  if (!calm) px.forEach(el => { const r = el.parentElement.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return; const k = parseFloat(el.dataset.parallax) || .15; el.style.transform = 'translate3d(0,' + ((r.top + r.height / 2 - vh / 2) * -k) + 'px,0) scale(1.15)'; });
  pins.forEach(sec => {
    const track = $('[data-htrack]', sec); if (!track) return;
    const r = sec.getBoundingClientRect(), max = track.scrollWidth - innerWidth + 40;
    if (innerWidth < 760 || calm) { sec.style.height = ''; track.style.transform = ''; return; }
    sec.style.height = (max + vh) + 'px';
    const k = Math.min(1, Math.max(0, -r.top / (sec.offsetHeight - vh)));
    track.style.transform = 'translate3d(' + (-max * k) + 'px,0,0)';
    const bar = $('[data-hbar]', sec); if (bar) bar.style.transform = 'scaleX(' + k + ')';
  });
  const y = scrollY; vel = vel * .85 + Math.abs(y - lastY) * .15; lastY = y;
  if (!calm) bands.forEach(b => { const a = b.getAnimations && b.getAnimations()[0]; if (a) a.playbackRate = 1 + Math.min(4, vel / 12); });
  if (vel > .2) req();
}
const req = () => { if (!ticking) { ticking = true; requestAnimationFrame(onFrame); } };
addEventListener('scroll', req, { passive: true }); addEventListener('resize', req); req();

/* ---------- announcement timer ---------- */
const annT = $$('.kp-ticker span').filter(s => s.textContent.indexOf('[timer]') > -1);
if (annT.length) {
  const tick = () => { const n = new Date(), c = new Date(n); c.setHours(KP.cutoff || 23, 0, 0, 0); let ms = c - n; if (ms < 0) ms += 864e5; const t = Math.floor(ms / 36e5) + 'h ' + String(Math.floor(ms / 6e4) % 60).padStart(2, '0') + 'm'; annT.forEach(s => { s.dataset.tpl = s.dataset.tpl || s.textContent; s.textContent = s.dataset.tpl.split('[timer]').join(t); }); };
  tick(); setInterval(tick, 30000);
}

/* ---------- predictive search ---------- */
const so = $('#kp-search');
if (so) {
  const inp = $('input', so), out = $('[data-search-out]', so);
  let tmr, last = '';
  document.addEventListener('click', e => { if (e.target.closest('[data-open-search]')) { e.preventDefault(); openModal(so); setTimeout(() => inp.focus(), 80); } });
  const run = async q => {
    if (q === last) return; last = q;
    if (q.length < 2) { out.innerHTML = ''; return; }
    out.classList.add('is-loading');
    try {
      const j = await (await fetch(R + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,article&resources[limit]=8&resources[options][unavailable_products]=last')).json();
      const r = (j.resources && j.resources.results) || {};
      let h = '';
      if ((r.collections || []).length) h += '<div class="kp-sr__chips">' + r.collections.slice(0, 5).map(c => '<a class="kp-tab" href="' + esc(c.url) + '">' + esc(c.title) + '</a>').join('') + '</div>';
      if ((r.products || []).length) h += '<h4 class="kp-sr__h">' + esc(T('products_label')) + '</h4><div class="kp-sr__grid">' + r.products.map((p, i) => '<a class="kp-sr__p" style="animation-delay:' + i * 40 + 'ms" href="' + esc(p.url) + '"><i>' + (p.image ? '<img src="' + esc(sized(p.image, 240)) + '" alt="" loading="lazy">' : '') + '</i><span>' + esc(p.title) + '</span><b>' + fmt(Math.round(parseFloat(p.price) * 100)) + '</b></a>').join('') + '</div>';
      if ((r.articles || []).length) h += '<h4 class="kp-sr__h">' + esc(T('articles_label')) + '</h4>' + r.articles.slice(0, 3).map(a => '<a class="kp-wishitem" href="' + esc(a.url) + '"><span>' + esc(a.title) + '</span></a>').join('');
      h += '<a class="kp-btn kp-btn--ghost" style="margin-top:14px" href="' + R + 'search?type=product&q=' + encodeURIComponent(q) + '">' + esc(T('search_all')) + ' &rarr;</a>';
      out.innerHTML = h;
    } catch (e) {}
    out.classList.remove('is-loading');
  };
  inp.addEventListener('input', () => { clearTimeout(tmr); tmr = setTimeout(() => run(inp.value.trim()), 180); });
  $$('[data-search-q]', so).forEach(b => b.addEventListener('click', () => { inp.value = b.dataset.searchQ; run(b.dataset.searchQ); }));
}

/* ---------- quick view ---------- */
const qv = $('#kp-qv');
if (qv) {
  const body = $('[data-qv-body]', qv);
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-quick-view]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    b.classList.add('is-loading');
    try {
      const p = await (await fetch(R + 'products/' + encodeURIComponent(b.dataset.quickView) + '.js')).json();
      let cur = p.variants.find(v => v.available) || p.variants[0], sel = cur.options.slice();
      const imgs = (p.images || []).slice(0, 6);
      const draw = () => {
        const sale = cur.compare_at_price > cur.price;
        body.innerHTML = '<div class="kp-qv__media"><div class="kp-qv__main"><img data-qv-img src="' + esc(sized((cur.featured_image && cur.featured_image.src) || imgs[0] || '', 900)) + '" alt=""></div>' + (imgs.length > 1 ? '<div class="kp-qv__thumbs">' + imgs.map(u => '<button type="button" data-qv-thumb="' + esc(u) + '"><img src="' + esc(sized(u, 160)) + '" alt=""></button>').join('') + '</div>' : '') + '</div>' +
          '<div class="kp-qv__info"><span class="kp-eyebrow">' + esc(p.type || '') + '</span><h2 class="kp-h3">' + esc(p.title) + '</h2><div class="kp-pdp__price"><span class="kp-price" style="font-size:32px">' + fmt(cur.price) + '</span>' + (sale ? '<s class="kp-compare" style="font-size:18px">' + fmt(cur.compare_at_price) + '</s><span class="kp-badge">-' + Math.round((1 - cur.price / cur.compare_at_price) * 100) + '%</span>' : '') + '</div>' +
          (p.variants.length > 1 ? p.options.map((o, oi) => '<div class="kp-opt"><span class="kp-opt__l">' + esc(o.name) + ': <b>' + esc(sel[oi]) + '</b></span><div class="kp-opt__vals">' + o.values.map(v => '<button type="button" class="kp-optbtn' + (sel[oi] === v ? ' is-on' : '') + '" data-qo="' + oi + '" data-qval="' + esc(v) + '">' + esc(v) + '</button>').join('') + '</div></div>').join('') : '') +
          '<button type="button" class="kp-btn kp-btn--big kp-shine" data-qv-add' + (cur.available ? '' : ' disabled') + '>' + esc(cur.available ? T('add') : T('sold_out')) + ' &middot; ' + fmt(cur.price) + '</button>' +
          '<a href="' + esc(p.url) + '" class="kp-linkbtn" style="text-align:center">' + esc(T('view_details')) + ' &rarr;</a></div>';
      };
      draw();
      body.onclick = ev => {
        const o = ev.target.closest('[data-qo]');
        if (o) { sel[+o.dataset.qo] = o.dataset.qval; cur = p.variants.find(v => v.options.every((x, i) => x === sel[i])) || cur; draw(); return; }
        const th = ev.target.closest('[data-qv-thumb]'); if (th) { $('[data-qv-img]', body).src = sized(th.dataset.qvThumb, 900); return; }
        const ad = ev.target.closest('[data-qv-add]'); if (ad && cur.available) { addItems([{ id: cur.id, quantity: 1 }], ad); setTimeout(() => closeModal(qv), 300); }
      };
      openModal(qv);
    } catch (err) {}
    b.classList.remove('is-loading');
  });
}

/* ---------- cart add-on (e.g. gift wrap / toy cleaner) ---------- */
document.addEventListener('kp:cart', e => {
  const c = e.detail, A = KP.addon;
  const box = $('[data-upsell]', $('#kp-drawer') || document);
  if (!A || !A.variant || !box || !c.item_count) return;
  const line = c.items.find(i => i.variant_id === A.variant);
  const el = document.createElement('label');
  el.className = 'kp-addon' + (line ? ' is-on' : '');
  el.innerHTML = '<input type="checkbox"' + (line ? ' checked' : '') + '><span class="kp-check">\u2713</span>' + (A.img ? '<img src="' + esc(sized(A.img, 120)) + '" alt="">' : '') + '<span class="kp-addon__t"><b>' + esc(A.title) + '</b><small>' + esc(A.text || '') + '</small></span><b class="kp-accent">+' + fmt(A.price) + '</b>';
  box.parentNode.insertBefore(el, box);
  $('input', el).addEventListener('change', async ev => {
    el.classList.add('is-loading');
    try { if (ev.target.checked) await api('cart/add.js', { items: [{ id: A.variant, quantity: 1 }] }); else if (line) await api('cart/change.js', { id: line.key, quantity: 0 }); } catch (err) {}
    X.refresh();
  });
});

/* ---------- forms posted via fetch (newsletter popup, notify me) ---------- */
async function postForm(form) {
  const fd = new FormData(form);
  const r = await fetch(form.action || (R + 'contact'), { method: 'POST', body: fd, headers: { Accept: 'text/html' } });
  if (/challenge/.test(r.url)) { form.submit(); return false; }
  return r.ok;
}

/* ---------- welcome popup (exit intent) ---------- */
const wl = $('#kp-welcome');
if (wl && !store.get('kp_welcome', false) && !store.get('kp_code', null)) {
  let shown = false;
  const show = () => { if (shown || $('.kp-modal.is-open') || $('#kp-age') || ($('#kp-drawer') && $('#kp-drawer').classList.contains('is-open'))) return; shown = true; store.set('kp_welcome', true); openModal(wl); };
  if (fine) document.addEventListener('mouseout', e => { if (!e.relatedTarget && e.clientY < 8) show(); });
  else { let maxY = 0; addEventListener('scroll', () => { maxY = Math.max(maxY, scrollY); if (maxY > 1600 && scrollY < maxY - 600) show(); }, { passive: true }); }
  if (+wl.dataset.delay > 0) setTimeout(show, +wl.dataset.delay * 1000);
  const f = $('form', wl);
  f && f.addEventListener('submit', async e => {
    e.preventDefault();
    const btn = $('[type=submit]', f); btn.classList.add('is-loading');
    try { if (await postForm(f) === false) return; } catch (err) {}
    btn.classList.remove('is-loading');
    wl.classList.add('is-done');
    const code = wl.dataset.code; if (code) { store.set('kp_code', code); fetch(R + 'discount/' + encodeURIComponent(code)).catch(() => {}); }
    const r = wl.querySelector('.kp-modal__box').getBoundingClientRect(); burst(r.left + r.width / 2, r.top + 80, 70);
  });
}

/* ---------- notify me (sold out) ---------- */
$$('[data-notify]').forEach(n => {
  const pdp = n.closest('[data-pdp]'), atc = pdp && $('[data-atc]', pdp);
  const sync = () => { n.hidden = !(atc && atc.disabled); const v = $('[data-vid]', pdp); const b = $('[name="contact[body]"]', n); if (b && v) b.value = n.dataset.title + ' — variant ' + v.value; };
  sync();
  if (atc) new MutationObserver(sync).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
  const f = $('form', n);
  f && f.addEventListener('submit', async e => { e.preventDefault(); try { if (await postForm(f) === false) return; } catch (err) {} f.innerHTML = '<p class="kp-note">' + esc(T('notify_ok')) + '</p>'; });
});

/* ---------- share ---------- */
document.addEventListener('click', async e => {
  const b = e.target.closest('[data-share]'); if (!b) return;
  e.preventDefault();
  const url = b.dataset.url || location.href, title = b.dataset.title || document.title;
  if (navigator.share) { try { await navigator.share({ title, url }); } catch (err) {} return; }
  try { await navigator.clipboard.writeText(url); toast(T('copied')); } catch (err) { location.href = 'https://wa.me/?text=' + encodeURIComponent(title + ' ' + url); }
});

/* ---------- generic modal openers (size guide etc.) ---------- */
document.addEventListener('click', e => { const b = e.target.closest('[data-open-modal]'); if (b) { e.preventDefault(); openModal(document.getElementById(b.dataset.openModal)); } });

/* ---------- bundle builder ---------- */
$$('[data-box]').forEach(box => {
  const need = +box.dataset.need || 4, code = box.dataset.code, items = $$('[data-box-item]', box), tray = $('[data-box-tray]', box), bar = $('[data-box-bar]', box), btn = $('[data-box-add]', box), lab = $('[data-box-label]', box), tot = $('[data-box-total]', box);
  let picked = [];
  const draw = () => {
    items.forEach(i => { const n = picked.filter(p => p === i).length; i.classList.toggle('is-on', n > 0); const c = $('[data-box-n]', i); if (c) c.textContent = n ? '\u00d7' + n : ''; });
    tray.innerHTML = Array.from({ length: need }, (_, k) => { const p = picked[k]; return '<span class="kp-box__slot' + (p ? ' is-full' : '') + '">' + (p ? '<img src="' + esc(p.dataset.img) + '" alt=""><button type="button" data-box-rm="' + k + '" aria-label="remove">\u00d7</button>' : (k + 1)) + '</span>'; }).join('');
    bar.style.width = (picked.length / need * 100) + '%';
    const left = need - picked.length;
    btn.disabled = left > 0;
    lab.textContent = left > 0 ? T('box_need', { count: left }) : T('box_add');
    if (tot) tot.textContent = fmt(picked.reduce((a, p) => a + (+p.dataset.price || 0), 0));
  };
  box.addEventListener('click', e => {
    const rm = e.target.closest('[data-box-rm]'); if (rm) { picked.splice(+rm.dataset.boxRm, 1); draw(); return; }
    const it = e.target.closest('[data-box-item]');
    if (it && !e.target.closest('a')) {
      if (picked.length >= need) { toast(T('box_add')); return; }
      picked.push(it); draw();
      const r = it.getBoundingClientRect(); burst(r.left + r.width / 2, r.top + r.height / 2, 10);
      if (picked.length === need) { const b = btn.getBoundingClientRect(); burst(b.left + b.width / 2, b.top, 40); }
    }
  });
  btn.addEventListener('click', async () => {
    if (picked.length < need) return;
    const map = {}; picked.forEach(p => { map[p.dataset.variant] = (map[p.dataset.variant] || 0) + 1; });
    if (code) { store.set('kp_code', code); fetch(R + 'discount/' + encodeURIComponent(code)).catch(() => {}); }
    await addItems(Object.keys(map).map(id => ({ id: +id, quantity: map[id] })), btn);
    picked = []; draw();
  });
  draw();
});

/* ---------- shop the look hotspots ---------- */
$$('[data-look]').forEach(l => {
  l.addEventListener('click', e => {
    const h = e.target.closest('[data-hot]'); if (!h) { if (!e.target.closest('.kp-look__card')) $$('.kp-look__card', l).forEach(c => c.classList.remove('is-on')); return; }
    const card = $('#' + h.dataset.hot);
    $$('.kp-look__card', l).forEach(c => { if (c !== card) c.classList.remove('is-on'); });
    $$('[data-hot]', l).forEach(x => x.classList.toggle('is-on', x === h && !card.classList.contains('is-on')));
    card.classList.toggle('is-on');
  });
});

/* ---------- article: toc ---------- */
$$('[data-toc]').forEach(t => {
  const art = $('[data-article]'); if (!art) return;
  const hs = $$('h2, h3', art); if (hs.length < 2) { t.hidden = true; return; }
  t.innerHTML = '<b>' + esc(T('contents')) + '</b>' + hs.map((h, i) => { h.id = h.id || 'kp-h-' + i; return '<a href="#' + h.id + '" class="' + (h.tagName === 'H3' ? 'is-sub' : '') + '">' + esc(h.textContent) + '</a>'; }).join('');
  const links = $$('a', t);
  if ('IntersectionObserver' in window) { const o = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) links.forEach(a => a.classList.toggle('is-on', a.getAttribute('href') === '#' + en.target.id)); }), { rootMargin: '0px 0px -70% 0px' }); hs.forEach(h => o.observe(h)); }
});

/* ---------- header hides on scroll down ---------- */
const hdr = $('#kp-header');
if (hdr && !calm) { let ly = scrollY; addEventListener('scroll', () => { const y = scrollY; if (Math.abs(y - ly) < 8) return; hdr.classList.toggle('is-hidden', y > ly && y > 400 && !document.querySelector('.kp-nav__item:hover')); ly = y; }, { passive: true }); }

/* ---------- instant navigation: prefetch on hover/touch ---------- */
const pre = new Set();
const prefetch = a => { if (!a || !a.href || pre.has(a.href)) return; const u = new URL(a.href, location.href); if (u.origin !== location.origin || u.hash || /\/(cart|checkout|account|discount)/.test(u.pathname)) return; pre.add(a.href); const l = document.createElement('link'); l.rel = 'prefetch'; l.href = a.href; document.head.appendChild(l); };
document.addEventListener('mouseover', e => { const a = e.target.closest('a[href]'); if (a) { clearTimeout(a.__pf); a.__pf = setTimeout(() => prefetch(a), 70); } }, { passive: true });
document.addEventListener('touchstart', e => prefetch(e.target.closest('a[href]')), { passive: true });

/* ---------- product gallery swipe (mobile) ---------- */
const zm = $('[data-zoom]');
if (zm) {
  let x0 = null;
  zm.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
  zm.addEventListener('touchend', e => {
    if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) < 40) return;
    const th = $$('[data-thumb]'); if (th.length < 2) return;
    let i = th.findIndex(t => t.classList.contains('is-on')); i = (i + (dx < 0 ? 1 : -1) + th.length) % th.length; th[i].click();
  }, { passive: true });
}

/* ---------- mega menu (touch) ---------- */
$$('.kp-nav__item > a').forEach(a => a.addEventListener('click', e => { if (!fine && a.parentElement.querySelector('.kp-mega')) { const open = a.parentElement.classList.toggle('is-open'); if (open) e.preventDefault(); } }));

})();
